var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDefaultIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 14,
  fill: "none",
  viewBox: "0 0 13 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#169A5B",
  d: "M8.832 1.422c1.996 1.832 3.418 4.84 3.418 6.289C12.25 11.184 9.488 14 6.125 14 2.735 14 0 11.184 0 7.71 0 5.743 1.887 2.517 4.594 0 5.633.984 6.562 2.023 7.3 3.063c.465-.575.957-1.122 1.531-1.641m-.52 9.297c1.34-.93 1.641-2.762.903-4.184a12 12 0 0 0-.3-.547L7.3 7.82S4.785 4.594 4.594 4.375C3.28 5.988 2.625 6.918 2.625 7.957c0 2.133 1.586 3.418 3.555 3.418.793 0 1.53-.246 2.133-.656"
})));
export default SvgDefaultIcon;